"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var __1 = require("../../..");
var react_ga4_1 = __importDefault(require("react-ga4"));
var OrderComment = function () {
    var _a = (0, react_hook_form_1.useForm)(), handleSubmit = _a.handleSubmit, register = _a.register, setValue = _a.setValue;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var _c = (0, react_1.useState)(true), isConditionAccept = _c[0], setIsConditionAccept = _c[1];
    var _d = (0, react_1.useState)(), orderHashId = _d[0], setOrderHashId = _d[1];
    var _e = (0, react_1.useState)('#'), url = _e[0], setUrl = _e[1];
    var _f = (0, react_1.useState)(), isEmpty = _f[0], setIsEmpty = _f[1];
    var _g = (0, react_1.useState)(false), isView = _g[0], setIsView = _g[1];
    var textAreaRef = (0, react_1.useRef)(null);
    var onSubmit = function (data) {
        var _a;
        console.log(data);
        if (!((_a = data.comment) === null || _a === void 0 ? void 0 : _a.length)) {
            setIsEmpty(true);
        }
        else {
            setIsEmpty(false);
            axios_1.default.post("/app/comment/order", data)
                .then(function (response) {
                console.log(response.data);
                if (response.status == 200) {
                    setIsView(true);
                }
            }).catch(function (error) {
                console.log("error", error);
            });
        }
        /*
        axios.post(`/app/comment/order`,data)
            .then((response) => {
                console.log(response.data);
                if (response.status == 200) {

                }

            }).catch(error => {
                console.log("error", error);
            });

        */
    };
    (0, react_1.useEffect)(function () {
        var formNode = document.getElementById("react-comments-order");
        var hash = formNode === null || formNode === void 0 ? void 0 : formNode.getAttribute('data-hash-id');
        if (hash) {
            console.log(hash);
            setOrderHashId(hash);
            setValue('order_hash_id', hash);
            axios_1.default.get("/app/order/purchase-info/".concat(hash))
                .then(function (response) {
                if (response.status == 200) {
                    if (__1.SETUP_LOCAL_APP) {
                        react_ga4_1.default.initialize(__1.GA_ID);
                        react_ga4_1.default.event("purchase", {
                            currency: response.data.currency,
                            value: response.data.value,
                            transaction_id: response.data.transaction_id,
                            //coupon: value.promocode?.name,
                            items: [{
                                    item_id: response.data.item_id,
                                    item_name: response.data.item_name
                                }]
                        });
                    }
                }
            }).catch(function (error) {
                console.log("error", error);
            });
            //console.log(hash);
        }
    }, []);
    return (react_1.default.createElement(react_1.Fragment, null, !isView
        ?
            react_1.default.createElement("form", { onSubmit: handleSubmit(onSubmit) },
                react_1.default.createElement("div", { className: "__order-checkout" },
                    react_1.default.createElement("input", __assign({ type: "hidden" }, register('order_hash_id'))),
                    react_1.default.createElement("span", { className: "__comment" }, t("order.status.comment.caption")),
                    react_1.default.createElement("textarea", __assign({ className: (0, classnames_1.default)(isEmpty && "has-error-input") }, register('comment'), { placeholder: t("order.payment.comment.placeholder") }))),
                react_1.default.createElement("div", { style: { width: "100%", justifyContent: "flex-end", alignItems: "flex-end" }, className: "__wrap-checkout-button" },
                    react_1.default.createElement("div", { className: "__wrap-button" },
                        react_1.default.createElement("button", { type: "submit", className: "__to-checkout" }, t("order.status.comment.submit")))))
        :
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { className: "__comment" }, t("order.status.comment.sumit")))));
};
exports.default = OrderComment;
